import React, { useEffect, useState } from 'react'
import axios from '../../../utils/axiosConfig';
import Swal from 'sweetalert2';

const FormModalCreatePermission = ({ onClose, idEditPermission, data }) => {

    const [nombrePermission, setNombrePermission] = useState('');
    const [notas, setNotas] = useState('');

    const savePage = () => {
        console.log('pagina:', nombrePermission);
        if (idEditPermission !== -1) {
            // Lógica para editar el permiso
            if (nombrePermission.trim() === '') {
                Swal.fire('Error', 'El nombre de la página no puede estar vacío', 'error');
                return;
            }
            let dataUpdate = {
                IdPagina: idEditPermission,
                DescripcionPagina: nombrePermission,
                NotasPagina: notas
            }
            console.log('Datos a actualizar:', dataUpdate);
            axios.post(process.env.REACT_APP_SERVER + '/usuarios/crearpagina', JSON.stringify(dataUpdate), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('tkn')}`
                },
                withCredentials: true
            }).then(res => {
                console.log('Página actualizada:', res.data);
                Swal.fire('Éxito', 'La página ha sido actualizada exitosamente', 'success');
                onClose();
            }).catch(error => {
                console.error('Error al guardar página:', error);
            });
        } else {
            // Lógica para crear un nuevo rol
            if (nombrePermission.trim() === '') {
                Swal.fire('Error', 'El nombre de la página no puede estar vacío', 'error');
                return;
            }
            let dataCreate = {
                IdPagina: -1,
                DescripcionPagina: nombrePermission,
                NotasPagina: notas
            }

            console.log('Creando pagina con datos:', dataCreate);
            axios.post(process.env.REACT_APP_SERVER + '/usuarios/crearpagina', JSON.stringify(dataCreate), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('tkn')}`
                },
                withCredentials: true
            }).then(res => {
                console.log('Página creada:', res.data);
                Swal.fire('Éxito', 'La página ha sido creada exitosamente', 'success');
                onClose();
            }).catch(error => {
                console.error('Error al guardar página:', error);
            });
        }

    }

    useEffect(() => {
        if (data) {
            console.log('Editando permiso:', data);
            setNombrePermission(data.path || '');
            setNotas(data.Notas || '');
        }
    }, [data]);
    return (
        <div>
            <form>
                <div className="mb-3">
                    <label htmlFor="permissionName" className="form-label">Nombre de la página</label>
                    <input type="text" className="form-control" id="permissionName" style={{ boxSizing: 'border-box' }}
                        value={nombrePermission}
                        onChange={(e) => setNombrePermission(e.target.value)}
                        autoFocus
                        placeholder='Nombre de la página' />
                </div>
                <div className="mb-3">
                    <label htmlFor="notas" className="form-label">Notas</label>
                    <input type="text" className="form-control" id="notas" style={{ boxSizing: 'border-box' }}
                        value={notas}
                        onChange={(e) => setNotas(e.target.value)}
                        placeholder='Notas' />
                </div>
                <button type="button" className="btn btn-primary" onClick={() => { savePage() }}>{idEditPermission !== -1 ? 'Actualizar' : 'Crear'}</button>
            </form>
        </div>
    )
}

export default FormModalCreatePermission
